import { formatDate } from "@/helpers/dateProcessor";

export const roofStructureTableColumns = {
  label: {
    formatDataKey: "Label",
    formatDataValue: (arg: string) => arg,
    allowInAdvancedFilter: true,
    allowInTableOptions: true,
    visibleByDefault: true,
    allowSort: true,
    position: 0
  },
  value: {
    formatDataKey: "Value",
    formatDataValue: (arg: string) => arg,
    allowInAdvancedFilter: true,
    allowInTableOptions: true,
    visibleByDefault: true,
    allowSort: true,
    position: 1
  },
  createdOn: {
    formatDataKey: "Created At",
    formatDataValue: (arg: string) => (arg ? formatDate(arg) : "—"),
    allowInAdvancedFilter: true,
    allowInTableOptions: true,
    visibleByDefault: true,
    allowSort: true,
    position: 2
  }
};
